import React from 'react';
import { Box, Divider } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AreaTitle from '../../../../components/areaTitle/AreaTitle';

const MassMessagingHeader = () => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <AreaTitle
          Title="Envio em Massa"
          Icon={<MailOutlineIcon />}
          Description="Envie mensagens para múltiplos contatos de uma só vez"
        />
      </Box>
      
      <Divider sx={{ margin: '16px 0 24px 0' }} />
    </>
  );
};

export default MassMessagingHeader;